import Alpine from 'alpinejs'
//import TomSelect from 'tom-select'
import wire_replace from '@leanadmin/wire-replace';

window.Alpine = Alpine
//window.TomSelect = TomSelect
Alpine.start()

window.Livewire.hook(...wire_replace);

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
